import { DataLayer } from '@shared/types/data-layer';

export interface State {
    data: DataLayer;
}

export const initialState: State = {
    data: null,
};
